{
  "familyId": "GET-WETENSCHAPPELIJK",
  "questions": [
    {
      "id": "GET-WETENSCHAPPELIJK-001",
      "familyId": "GET-WETENSCHAPPELIJK",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_notatie",
      "questionType": "multiple_choice",
      "question": "Wat betekent $3 \\times 10^2$?",
      "context": null,
      "options": ["300", "30", "3000", "23"],
      "correctAnswer": 0,
      "conceptId": "scientific_notation_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.75,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wetenschappelijke notatie",
            "content": "$a \\times 10^n$ = a × (10 tot de macht n). De exponent n zegt hoe vaak je 10 vermenigvuldigt. Voorbeeld: $3 \\times 10^2$ = 3 × 100 = 300."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 300. $3 \\times 10^2$ betekent: 3 × (10 × 10) = 3 × 100 = 300. De exponent 2 zegt dat je 10 twee keer vermenigvuldigt.",
        "distractorExplanations": {
          "0": "Goed! $3 \\times 10^2$ = 3 × 100 = 300.",
          "1": "30 is fout. Je hebt misschien $3 \\times 10^1$ = 30 berekend (exponent 1 in plaats van 2). $3 \\times 10^2$ = 3 × 100 = 300.",
          "2": "3000 is fout. Je hebt misschien $3 \\times 10^3$ = 3000 berekend (exponent 3 in plaats van 2). $3 \\times 10^2$ = 3 × 100 = 300.",
          "3": "23 is fout. Je hebt misschien 3 + 20 = 23 berekend. Maar $3 \\times 10^2$ betekent vermenigvuldigen: 3 × 100 = 300."
        }
      }
    },
    {
      "id": "GET-WETENSCHAPPELIJK-002",
      "familyId": "GET-WETENSCHAPPELIJK",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_notatie",
      "questionType": "multiple_choice",
      "question": "Schrijf 5000 in wetenschappelijke notatie:",
      "context": null,
      "options": ["$5 \\times 10^3$", "$5 \\times 10^2$", "$50 \\times 10^2$", "$5 \\times 10^4$"],
      "correctAnswer": 0,
      "conceptId": "scientific_notation_write",
      "variantIndex": 2,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.78,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Getal omzetten naar wetenschappelijke notatie",
            "content": "Stap 1: Schrijf het getal als a × 10^n, waarbij 1 ≤ a < 10. Stap 2: Tel het aantal nullen → dat is de exponent. 5000 = 5 × 1000 = 5 × 10^3."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $5 \\times 10^3$. Stap 1: 5000 = 5 × 1000. Stap 2: 1000 = $10^3$. Dus 5000 = $5 \\times 10^3$. Regel: tel het aantal nullen → dat is de exponent.",
        "distractorExplanations": {
          "0": "Goed! 5000 = 5 × 1000 = $5 \\times 10^3$.",
          "1": "$5 \\times 10^2$ is fout. $5 \\times 10^2$ = 5 × 100 = 500, niet 5000. Je hebt de exponent te klein genomen. Tel de nullen: 5000 heeft 3 nullen → $10^3$.",
          "2": "$50 \\times 10^2$ is fout. Bij wetenschappelijke notatie moet het grondtal tussen 1 en 10 liggen. 50 is te groot. Schrijf als $5 \\times 10^3$.",
          "3": "$5 \\times 10^4$ is fout. $5 \\times 10^4$ = 5 × 10000 = 50000, niet 5000. Je hebt de exponent te groot genomen. 5000 heeft 3 nullen → $10^3$."
        }
      }
    },
    {
      "id": "GET-WETENSCHAPPELIJK-003",
      "familyId": "GET-WETENSCHAPPELIJK",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_notatie",
      "questionType": "multiple_choice",
      "question": "Bereken: $2 \\times 10^3$ + $3 \\times 10^3$ =",
      "context": null,
      "options": ["$5 \\times 10^3$", "$5 \\times 10^6$", "$6 \\times 10^3$", "$2{,}3 \\times 10^3$"],
      "correctAnswer": 0,
      "conceptId": "scientific_notation_add",
      "variantIndex": 3,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.8,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Optellen met wetenschappelijke notatie",
            "content": "Als de exponenten gelijk zijn, tel je alleen de grondtallen op. De macht blijft hetzelfde. $2 \\times 10^3$ + $3 \\times 10^3$ = (2+3) × $10^3$ = $5 \\times 10^3$."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $5 \\times 10^3$. De exponenten zijn gelijk ($10^3$), dus tel je alleen de grondtallen op: 2 + 3 = 5. De macht $10^3$ blijft hetzelfde. Dus $2 \\times 10^3$ + $3 \\times 10^3$ = $5 \\times 10^3$.",
        "distractorExplanations": {
          "0": "Goed! Gelijke exponenten: tel de grondtallen op: 2 + 3 = 5, macht blijft $10^3$. Dus $5 \\times 10^3$.",
          "1": "$5 \\times 10^6$ is fout. Je hebt de exponenten opgeteld (3 + 3 = 6). Dat mag niet bij optellen. Alleen de grondtallen tel je op: 2 + 3 = 5, macht blijft $10^3$.",
          "2": "$6 \\times 10^3$ is fout. Je hebt misschien 2 × 3 = 6 berekend (vermenigvuldigd in plaats van opgeteld). Tel op: 2 + 3 = 5, dus $5 \\times 10^3$.",
          "3": "$2{,}3 \\times 10^3$ is fout. Je hebt de grondtallen naast elkaar gezet (2,3) in plaats van opgeteld. Tel op: 2 + 3 = 5, dus $5 \\times 10^3$."
        }
      }
    },
    {
      "id": "GET-WETENSCHAPPELIJK-004",
      "familyId": "GET-WETENSCHAPPELIJK",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_notatie",
      "questionType": "multiple_choice",
      "question": "Welke is groter: $4 \\times 10^5$ of $7 \\times 10^4$?",
      "context": null,
      "options": ["$4 \\times 10^5$", "$7 \\times 10^4$", "ze zijn even groot", "dat kun je niet zeggen"],
      "correctAnswer": 0,
      "conceptId": "scientific_notation_compare",
      "variantIndex": 4,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.82,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wetenschappelijke notatie vergelijken",
            "content": "Bereken beide getallen uit: $4 \\times 10^5$ = 400.000 en $7 \\times 10^4$ = 70.000. Hogere exponent → groter getal (als grondtal > 0)."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $4 \\times 10^5$. Bereken beide: $4 \\times 10^5$ = 4 × 100000 = 400000. $7 \\times 10^4$ = 7 × 10000 = 70000. Dus 400000 > 70000. Regel: hogere exponent → groter getal (als grondtal > 0).",
        "distractorExplanations": {
          "0": "Goed! $4 \\times 10^5$ = 400000 en $7 \\times 10^4$ = 70000. 400000 > 70000.",
          "1": "$7 \\times 10^4$ is fout. Je hebt misschien alleen naar het grondtal (7 > 4) gekeken. Maar de exponent is doorslaggevend: $10^5$ = 100000 vs $10^4$ = 10000. $4 \\times 10^5$ = 400000 > $7 \\times 10^4$ = 70000.",
          "2": "Ze zijn niet even groot. $4 \\times 10^5$ = 400000 en $7 \\times 10^4$ = 70000. Bereken altijd beide getallen uit voordat je vergelijkt.",
          "3": "Je kunt het wél zeggen. Bereken beide: $4 \\times 10^5$ = 400000 en $7 \\times 10^4$ = 70000. $4 \\times 10^5$ is groter."
        }
      }
    }
  ]
}
